// extracted by mini-css-extract-plugin
module.exports = {"title":"Documents_title__22ZUX","selects":"Documents_selects__2kkqX"};